import { request as graphqlRequest, type Variables } from 'graphql-request';
import type { RequestDocument } from 'graphql-request';
import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import type { Query } from './models';
import { environment, datoApiKey } from './environment';

export function request<TDocument = Query>(
    document: RequestDocument | TypedDocumentNode<TDocument, Variables>,
    variables?: Variables
) {
    return graphqlRequest<TDocument, Variables>("https://graphql.datocms.com/", document, variables, {
      Authorization: `Bearer ${datoApiKey}`,
      "X-Exclude-Invalid": "true",
      "X-Include-Drafts": "true",
      "X-Environment": environment,
    });
}
